import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// material
import { Typography, Stack, Container, IconButton } from '@mui/material';
import DeleteReasonPopup from '../moreMenuComponent/DeleteReasonPopup';
import Iconify from '../../../components/iconify';
// --------------------------------------------------------------------------------------------------------

GridToolbarMultipleDelete.propTypes = {
    numSelected: PropTypes.number,
    rowIndex: PropTypes.array,
    rowData: PropTypes.array,
    masterName: PropTypes.string,
};
// --------------------------------------------------------------------------------------------------------

export default function GridToolbarMultipleDelete({ numSelected, rowIndex, rowData, masterName }) {

    const [openModalForDelete, setOpenModalDelete] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState([]);

    useEffect(() => {
        for (let i = 0; i < rowIndex.length; i += 1) {
            setSelectedRows((row) => [...row, rowData[rowIndex[i]]])
        }

    }, [rowIndex, rowData]);

    const handleDelete = () => {
        if (!rowIndex?.length) return;
        if (masterName !== "helptopic" && masterName !== "subcategory" && masterName !== "helpcategory" && masterName !== "tags") {
            const ids = rowIndex.map(r => r.id);
            setSelectedRowId(ids);
            setOpenModalDelete(true);
        }
        else {
            selectedRows.map((row) => {
                setSelectedRowId((rowId) => [...rowId, row.id]);
                return null;
            })
            setOpenModalDelete(true);
        }
    };

    const handleConfirmation = () => {
        setOpenModalDelete(false);
        window.location.reload();
    };

    return (
        <>
            {numSelected > 0 && (
                <Container sx={{ bgcolor: 'primary.lighter', py: 0.5, mt: '4px' }}>
                    <Stack direction="row" alignItems='center' justifyContent='space-between' flexGrow={1} >
                        <Typography variant="subtitle1" color='primary.main'>
                            {numSelected} selected
                        </Typography>

                        <IconButton onClick={handleDelete}>
                            <Iconify icon="eva:trash-2-outline" width='22px' height='22px' color="primary.main" />
                        </IconButton>
                    </Stack>
                </Container>
            )}

            {openModalForDelete && <DeleteReasonPopup confirm={handleConfirmation} selectedRow={selectedRowId}
                masterName={masterName} />}
        </>
    );
}
